module.exports = __webpack_public_path__ + "img/order-active.ea336c93.svg";